import React from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';
import { ApproachSelection } from '../ApproachSelection';
import { StepHeader } from '../StepHeader';
import { getStepStatus, toggleStep } from '../../utils/rankAListHelpers';

interface ApproachSelectionStepProps {
  step: number;
  expandedSteps: number[];
  setExpandedSteps: (steps: number[]) => void;
  approach: 'prediction' | 'similarity';
  onSelect: (approach: 'prediction' | 'similarity') => void;
}

export const ApproachSelectionStep: React.FC<ApproachSelectionStepProps> = ({
  step,
  expandedSteps,
  setExpandedSteps,
  approach,
  onSelect
}) => {
  const isOpen = expandedSteps.includes(4);
  
  const getTitle = () => {
    if (step >= 4) {
      const approachText = approach === 'prediction' ? 'Prediction Score' : 'Similarity Search';
      return `Choose Approach: ${approachText}`;
    }
    return 'Choose Approach';
  };
  
  return (
    <Collapsible 
      open={isOpen} 
      className="border border-slate-600 rounded-lg bg-slate-800"
    >
      <CollapsibleTrigger asChild>
        <button className="w-full" onClick={() => toggleStep(4, expandedSteps, setExpandedSteps)}>
          <StepHeader 
            stepNumber={4} 
            title={getTitle()} 
            status={getStepStatus(step, 4)}
            isOpen={isOpen}
          />
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent className="px-4 pb-4">
        <ApproachSelection 
          onSelect={onSelect}
          selected={approach}
          disabled={false}
        />
      </CollapsibleContent>
    </Collapsible>
  );
}; 